import { FusaReply } from '@/types/replyTypes';
import { CreateReferenceRequest, CreateReferenceResponse, ReferenceResponse, ReferencesResponse } from '@/types/itemReferenceTypes';
import { Client } from "./client";

export class ReferenceController {
  client: Client;

  constructor() {
    this.client = new Client();
  }

  public async createReference(req: CreateReferenceRequest): Promise<CreateReferenceResponse> {
    return this.client.create(`/api/item-references`, req);
  }

  public async deleteReference(id: string): Promise<FusaReply> {
    return this.client.delete(`/api/item-references/${id}`,);
  }

  public async readAllReferences(procedureId: string): Promise<ReferencesResponse> {
    return this.client.read(`/api/item-references?procedureId=${procedureId}`);
  }

  public async enableReference(id: string): Promise<ReferenceResponse> {
    return this.client.update(`/api/item-references/enable/${id}`, {});
  }
}
